import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LangProvider } from "../contexts/LangContext";
import { ForgotPasswordPage } from "../pages/ForgotPasswordPage";

export const Route = createFileRoute("/forgot-password")({
  head: () => ({
    meta: [{ title: "Parolni tiklash — Lotin.uz" }],
    htmlProps: { lang: "uz-Latn" },
  }),
  component: ForgotPassword,
});

function ForgotPassword() {
  const { i18n } = useTranslation();
  useEffect(() => {
    document.documentElement.lang = "uz-Latn";
    if (i18n?.changeLanguage) i18n.changeLanguage("default");
  }, [i18n]);
  return (
    <LangProvider lang={"uz-Latn"}>
      <ForgotPasswordPage />
    </LangProvider>
  );
}
